export const STRIPE_URL: string = 'https://js.stripe.com/v3/';
